import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Redirect from '../components/Epic/Redirect'
import Launch from '../components/Epic/Launch'
import NotFound from '../components/NotFound'
import Finish from '../components/Epic/Finish'
import Idle from '../components/Epic/Idle'
import Configurator from '../components/Configurator'
import Login from '../components/Auth/Login'
import Verify from '../components/Auth/Verify'
import Validate from '../components/Auth/Validate'
import ForgotPassword from '../components/Auth/ForgotPassword'
import HealthSystem from '../components/HealthSystem'
import ChangePassword from '../components/Auth/ChangePassword'

const Routes = () => {
  return (
    <Router>
      <Container fluid>
        <Switch>
          <Route path='/' exact component={Redirect} />
          <Route path='/fhir/epic/launch' exact component={Launch} />
          <Route path='/close/:step' exact component={Finish} />
          <Route path='/unauth' exact component={Idle} />
          <Route path='/configurator' exact component={Configurator} />
          <Route path='/health-system/:tenant/:screen?' exact component={HealthSystem} />
          <Route path='/login' exact component={Login} />
          <Route path='/verify' exact component={Verify} />
          <Route path='/validate' exact component={Validate} />
          <Route path='/forgot-password' exact component={ForgotPassword} />
          <Route path='/change-password' exact component={ChangePassword} />
          <Route path='*' component={NotFound} />
        </Switch>
      </Container>
    </Router>
  )
}

export default Routes
